// Shared client-side constants
export const MOQ = 200; // Minimum Order Quantity — pieces per line item
export const QTY_STEP = 50; // Increment step for +/- buttons

// Ladies-wear categories (fashion focus only)
export const CATEGORIES = [
    "Bodysuit",
    "Cord Set",
    "Tops",
    "Dress",
    "Party Dress",
    "Double Dress",
    "Maternity Dress",
    "Trouser",
    "Leggings",
    "Stripe Trousers",
    "Night Dress",
    "PJs",
];

export const currencySymbol = (c) =>
    c === "GBP" ? "£" : c === "USD" ? "$" : c === "EUR" ? "€" : c === "INR" ? "₹" : "";
